import React, { Component } from 'react';
import {Alert, Card} from "antd";
import {getUser} from "../helpers/authentication";

export class Home extends Component {
  static displayName = Home.name;

  render () {
    return (
      <Card size="small" title={"InfoCop Web Interface ("+getUser()?.firstname+ " " + getUser()?.lastname+")"}  style={{ width: "100%", marginTop:10 }}>
        <Alert
            message="Report Generation"
            description="You can generate a report by using the Report Section on the side navigation menu and selecting the report type."
            type="info"
            showIcon
        />
      </Card>
    );
  }
}
